module.exports = __webpack_public_path__ + "img/logo_2022.de5e9bfb.jpg";